import { SubcategoryProcessingRule } from '../interfaces';

export const subcategoryIsAvailableRule: SubcategoryProcessingRule = context => {
	const unavailableIds = new Set(
		context.availabilities.flatMap(availability => availability.subcategoriasAsociadas ?? [])
	);

	return {
		...context,
		subcategories: context.subcategories.filter(
			subcategory => !unavailableIds.has(subcategory.idSubcategoria)
		),
	};
};
